module.exports = __webpack_public_path__ + "img/messages.80490955.svg";